"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ConditionalComponent = function ConditionalComponent(props) {
  var children = props.children,
    condition = props.condition;
  return condition ? children : null;
};

// Define propTypes;
ConditionalComponent.propTypes = {
  /** When this property is true, children will be output */
  condition: _propTypes.default.bool
};

// Define defaultProps;
ConditionalComponent.defaultProps = {
  condition: true
};

// Export component as default;
var _default = exports.default = ConditionalComponent;